import { createAction, props } from '@ngrx/store';
import { Analysis } from 'src/app/analysis/models/Analysis';
import { DWSMConfig } from 'src/app/masterdata/models/DWSMConfig';
import { JobType } from 'src/app/shared/models/JobType';
import { SystemError } from '../../shared/models/SystemError';
import { CriterionUpdate } from '../models/CriterionUpdate';
import { DWSMCalculationDTO } from '../models/DWSMCalculationDTO';
import { DWSMDashboardEntry } from '../models/DWSMDashboardEntry';
import { DWSMJob } from '../models/DWSMJob';
import { DWSMParams } from '../models/DWSMParams';
import { FileMoveForceCase } from '../models/FileMoveForceCase';
import { FileStatus } from '../models/FileStatus';
import { FileStatusUpdateOutliers } from '../models/FileStatusUpdateOutliers';
import { ForceCase } from '../models/ForceCase';
import { GloveForceCase } from '../models/GloveForceCaseType';
import { MainObject } from '../models/MainObject';
import { OverviewTMO } from '../models/OverviewTMO';
import { UpdateFileStatusParams } from '../models/UpdateFileStatusParams';
import { UploadOverviewDTO } from '../models/UploadOverviewDTO';
import { DwsmResultVariant } from '../models/DwsmResultVariant';
import { VerifyXsensDataTable } from '../models/VerifyXsensDataTable';
import { VariantDTO } from '../models/VariantDTO';
import { TvgTableItemDTO } from '../models/TvgTableItemDTO';
import { Marker } from '../models/Marker';
import { DropdownTvgDTO } from '../dwsm-video-player/model/DropdownTvgDTO';
import { VideoMarkerDTO } from '../dwsm-video-player/model/VideoMarkerDTO';
import { ResponseStatusAndTaskLengthByJobId } from 'src/app/dwsm/models/ResponseStatusAndTaskLengthByJobId';

export enum ActionTypes {
    GET_UPLOAD_OVERVIEW = '[DWSM API] Loading upload overview',
    GET_UPLOAD_OVERVIEW_SUCCESS = '[DWSM API] Load upload overview success',
    GET_UPLOAD_OVERVIEW_FAIL = '[DWSM API] Load upload overview fail',
    OPEN_DWSM_POPUP = '[DWSM Page] Opening DWSM Popup',
    CLOSE_DWSM_POPUP = '[DWSM Page] Closing DWSM Popup',
    START_DWSM_UPLOAD = '[DWSM Page] Start Uploading',
    START_DWSM_LITE_TMO_UPLOAD = '[DWSM Page] Start Lite TMO video uploading',
    START_DWSM_LITE_TMO_UPLOAD_SUCCESS = '[DWSM Page] Start Lite TMO video uploaded successfully',
    START_DWSM_LITE_TMO_UPLOAD_FAIL = '[DWSM Page] Start Lite TMO video upload failed',
    GET_STATUS_AND_TASK_LENGTH_BY_JOB_ID = '[DWSM API] Get Dwsm status and task length by job id',
    GET_STATUS_AND_TASK_LENGTH_BY_JOB_ID_SUCCESS = '[DWSM API] Get Dwsm status and task length by job id Success',
    GET_STATUS_AND_TASK_LENGTH_BY_JOB_ID_FAIL = '[DWSM API] Get Dwsm status and task length by job id Fail',
    DWSM_UPLOAD_SUCCESS = '[DWSM API] Dwsm Upload Success',
    DWSM_UPLOAD_FAIL = '[DWSM API] Dwsm Upload Fail',
    CANCEL_DWSM_UPLOAD = '[DWSM Page] Cancel Dwsm Upload',
    START_REDIRECT_PROCESS_FOR_SINGLE_FILE_UPLOAD = '[DWSM Page] Start Redirect Process for single file upload',
    OPEN_SINGLE_ANALYSIS_FROM_MVNX_SUCCESS = '[DWSM API] Open Single Analysis From Mvnx success',
    OPEN_SINGLE_ANALYSIS_FROM_MVNX_FAIL = '[DWSM API] Open Single Analysis From Mvnx failed',
    START_REDIRECT_PROCESS_FOR_TMO_AND_MULTIPLES_FILES_UPLOAD = '[DWSM Page] Start Redirect Process for TMO and multiple files upload',
    TRANSFER_RESULTS_TO_CACHE_BY_JOB_ID_SUCCESS = '[DWSM API] Transfer Results To Cache By Job Id success',
    TRANSFER_RESULTS_TO_CACHE_BY_JOB_ID_FAIL = '[DWSM API] Transfer Results To Cache By Job Id failed',
    SAVE_ANALYSIS_IN_CACHE_SUCCESS = '[DWSM API] Save Analysis In Cache success',
    SAVE_ANALYSIS_IN_CACHE_FAIL = '[DWSM API] Save Analysis In Cache failed',
    SET_ADVANCED_SETTINGS_PERSONAL_DEFAULTS = '[DWSM API] Set advanced settings personal defaults',
    SET_ADVANCED_SETTINGS_PERSONAL_DEFAULTS_SUCCESS = '[DWSM API] Set advanced settings personal defaults success',
    SET_ADVANCED_SETTINGS_PERSONAL_DEFAULTS_FAIL = '[DWSM API] Set advanced settings personal defaults fail',
    REANALYZE_WITH_CURRENT_INPUTS = '[DWSM API] Reanalyze with current inputs',
    REANALYZE_WITH_CURRENT_INPUTS_SUCCESS = '[DWSM API] Reanalyze with current inputs success',
    REANALYZE_WITH_CURRENT_INPUTS_FAIL = '[DWSM API] Reanalyze with current inputs fail',
    GET_CALCULATIONS_FOR_CURRENT_JOB = '[DWSM API] Get calculations for current job',
    GET_CALCULATIONS_FOR_CURRENT_JOB_SUCCESS = '[DWSM API] Get calculations for current job success',
    GET_CALCULATIONS_FOR_CURRENT_JOB_FAIL = '[DWSM API] Get calculations for current job fail',
    GET_CALCULATIONS_BY_JOB_ID = '[DWSM API] Get Xsens Calculations by job id',
    GET_CALCULATIONS_BY_JOB_ID_SUCCESS = '[DWSM API] Get Xsens Calculations by job id Success',
    GET_CALCULATIONS_BY_JOB_ID_FAIL = '[DWSM API] Get Xsens Calculations by job id Fail',
    UPDATE_STATUS_OUTLIER_OBJECT = '[DWSM API] Update Status Outlier Object',
    UPDATE_STATUS_OUTLIER_OBJECT_SUCCESS = '[DWSM API] Update Status Outlier Object Success',
    UPDATE_STATUS_OUTLIER_OBJECT_FAIL = '[DWSM API] Update Status Outlier Object Fail',
    RESET_VERIFY_XSENS_DATA_FOR_CURRENT_JOB = '[DWSM API] Reset Verify Xsens Data for current job',
    RESET_VERIFY_XSENS_DATA_FOR_CURRENT_JOB_SUCCESS = '[DWSM API] Reset Verify Xsens Data for current job Success',
    RESET_VERIFY_XSENS_DATA_FOR_CURRENT_JOB_FAIL = '[DWSM API] Reset Verify Xsens Data for current job Fail',
    CREATE_ANALYSIS_BY_JOB_ID = '[DWSM API] Create analysis by job id',
    CREATE_ANALYSIS_BY_JOB_ID_SUCCESS = '[DWSM API] Create analysis by job id Success',
    CREATE_ANALYSIS_BY_JOB_ID_FAIL = '[DWSM API] Create analysis by job id Fail',
    FILE_STATUS_UPDATE = '[DWSM API] File status update',
    FILE_STATUS_UPDATE_SUCCESS = '[DWSM API] File status updated successfully',
    FILE_STATUS_UPDATE_FAIL = '[DWSM API] File status update failed',
    FILE_MOVE_FORCE_CASE = '[DWSM API] File move force case',
    FILE_MOVE_FORCE_CASE_SUCCESS = '[DWSM API] File move force case was successful',
    FILE_MOVE_FORCE_CASE_FAIL = '[DWSM API] File move force case failed',
    RESET_MAIN_OBJECT_BY_JOB_ID = '[DWSM API] Reset main object',
    RESET_MAIN_OBJECT_BY_JOB_ID_SUCCESS = '[DWSM API] Reset main object success',
    RESET_MAIN_OBJECT_BY_JOB_ID_FAIL = '[DWSM API] Reset main object fail',
    UPDATE_DESCRIPTION_ON_FORCE_CASE = '[DWSM Page] Update descriptions on force cases',
    VALIDATE_FORCE_CASE_FIELDS = '[DWSM Page] Validate force case fields',
    UPDATE_FORCE_CASE_CRITERION = '[DWSM API] Update force case criterion',
    UPDATE_FORCE_CASE_CRITERION_SUCCESS = '[DWSM API] Update force case criterion success',
    UPDATE_FORCE_CASE_CRITERION_FAIL = '[DWSM API] Update force case criterion fail',
    UPDATE_FORCE_CASE_FORCE_VALUE = '[DWSM Page] Update force case force value',
    GET_UPLOAD_OVERVIEW_TMO = '[DWSM TMO API] Loading upload overview tmo',
    GET_UPLOAD_OVERVIEW_TMO_SUCCESS = '[DWSM TMO API] Load upload overview tmo success',
    GET_UPLOAD_OVERVIEW_TMO_FAIL = '[DWSM TMO API] Load upload overview tmo fail',
    RESET_OVERVIEW_TMO = '[DWSM TMO API] Reset overview tmo',
    RESET_OVERVIEW_TMO_SUCCESS = '[DWSM TMO API] Reset overview tmo success',
    RESET_OVERVIEW_TMO_TMO_FAIL = '[DWSM TMO API] Reset overview tmo fail success',
    UPDATE_FILE_STATUS = '[DWSM TMO API] Update file status',
    UPDATE_FILE_STATUS_SUCCESS = '[DWSM TMO API] Update file status success',
    UPDATE_FILE_STATUS_FAIL = '[DWSM TMO API] Update file status fail',
    REVERT_UPDATE_FILE_STATUS = '[DWSM TMO Page] Revert file status',
    UPDATE_TMO_PROCESS_FREQUENCY = '[DWSM TMO Page] Update Tmo process frequency',
    RECALCULATE_TMO = '[DWSM TMO API] Recalculate Tmo',
    RECALCULATE_TMO_SUCCESS = '[DWSM TMO API] Recalculate Tmo success',
    RECALCULATE_TMO_FAIL = '[DWSM TMO API] Recalculate Tmo fail',
    GET_DWSM_DASHBOARD = '[DWSM Job] Get DWSM Dashboard',
    GET_DWSM_DASHBOARD_SUCCESS = '[DWSM Job API] Get DWSM dashboard success',
    GET_DWSM_DASHBOARD_FAIL = '[DWSM Job API] Get DWSM dashboard fail',
    GET_DWSM_LITE_DASHBOARD_SUCCESS = '[DWSM Job API] Get DWSM Lite dashboard success',
    GET_DWSM_LITE_DASHBOARD_FAIL = '[DWSM Job API] Get DWSM Lite dashboard fail',
    GET_DWSM_TMO_DASHBOARD_SUCCESS = '[DWSM Job API] Get DWSM TMO dashboard success',
    GET_DWSM_TMO_DASHBOARD_FAIL = '[DWSM Job API] Get DWSM TMO dashboard fail',
    DELETE_DWSM_JOB_BY_ID = '[DWSM Job API] Delete DWSM Job by id',
    DELETE_DWSM_JOB_BY_ID_SUCCESS = '[DWSM Job API] Delete DWSM job by id success',
    DELETE_DWSM_JOB_BY_ID_FAIL = '[DWSM Job API] Delete DWSM job by id fail',
    OPEN_DWSM_POPUP_FROM_DASHBOARD_ENTRY = '[DWSM Dashboard] Open DWSM Popup from Dashboard Entry',
    SET_DASHBOARD_ENTRY_TO_STATE = '[DWSM Dashboard] Set Dashboard Entry to State',
    UPDATE_JOB_TO_FINISHED = '[DWSM API] Update job to finished',
    UPDATE_JOB_TO_FINISHED_SUCCESS = '[DWSM API] Update job to finished success',
    UPDATE_JOB_TO_FINISHED_FAIL = '[DWSM API] Update job to finished fail',
    UPDATE_DWSM_FORCE_CASE_TYPE = '[DWSM Page] Update DWSM Force Case Type',
    OPEN_FORCE_CASE_TYPE_POPUP = '[DWSM Page] Open Force Case Type Popup',
    CLOSE_FORCE_CASE_TYPE_POPUP = '[DWSM Page] Close Force Case Type Popup',
    LOAD_DWSM_MODULE = '[DWSM Page] Load DWSM Module',
    UPDATE_DWSM_FORCE_CASE_INPUT = '[DWSM Page] Update DWSM Force Case Input',
    UPDATE_VARIANT_TVG_LIST = '[DWSM Page] Update variant tvg List',
    UPDATE_ACTIVE_MARKERS = '[DWSM Page] Update active markers',
    REORDER_ACTIVE_MARKERS = '[DWSM Page] Reorder active markers',
    BACK_TO_TVG_ORDER = '[DWSM Page] Back to TVG order page',
    UPDATE_GRAPH_DATA_DATASET_OVERRIDE = '[DWSM Page] Update force case graph data dataset override',
    CREATE_ANALYSIS_FROM_TMO = '[DWSM API] Create analysis from TMO',
    CREATE_ANALYSIS_FROM_TMO_SUCCESS = '[DWSM API] Create analysis from TMO success',
    CREATE_ANALYSIS_FROM_TMO_FAIL = '[DWSM API] Create analysis from TMO fail',
    UPDATE_ACTIVE_VARIANT = '[DWSM Page] Update active variant',
    ADD_VARIANT = '[DWSM Page] Add variant',
    ADD_VARIANT_SUCCESS = '[DWSM Page] Add variant success',
    ADD_VARIANT_FAIL = '[DWSM Page] Add variant fail',
    DELETE_VARIANT = '[DWSM Page] Delete variant',
    DELETE_VARIANT_SUCCESS = '[DWSM Page] Delete variant success',
    DELETE_VARIANT_FAIL = '[DWSM Page] Delete variant fail',
    QUICK_VERIFY_TMO = '[DWSM Page] Quick verify TMO',
    QUICK_VERIFY_TMO_SUCCESS = '[DWSM Page] Quick verify TMO success',
    QUICK_VERIFY_TMO_FAIL = '[DWSM Page] Quick verify TMO fail',
    VERIFY_ALL_TMO = '[DWSM Page] Verify all TMO',
    VERIFY_ALL_TMO_SUCCESS = '[DWSM Page] Verify all TMO success',
    VERIFY_ALL_TMO_FAIL = '[DWSM Page] Verify all TMO fail',
    GET_CALCULATIONS_FOR_TVG = '[DWSM TMO API] Get Xsens Calculations for TVG',
    GET_CALCULATIONS_FOR_TVG_SUCCESS = '[DWSM TMO API] Get Xsens Calculations for TVG success',
    GET_CALCULATIONS_FOR_TVG_FAIL = '[DWSM TMO API] Get Xsens Calculations for TVG fail',
    VERIFY_TVG_AND_RETURN_TO_OVERVIEW = '[DWSM TMO Page] Verify TVG and return to overview',
    VERIFY_TVG_AND_RETURN_TO_OVERVIEW_SUCCESS = '[DWSM TMO Page] Verify TVG and return to overview success',
    VERIFY_TVG_AND_RETURN_TO_OVERVIEW_FAIL = '[DWSM TMO Page] Verify TVG and return to overview fail',
    VERIFY_TVG_AND_CONTINUE_TO_NEXT = '[DWSM TMO Page] Verify TVG and continue to next',
    VERIFY_TVG_AND_CONTINUE_TO_NEXT_SUCCESS = '[DWSM TMO Page] Verify TVG and continue to next success',
    VERIFY_TVG_AND_CONTINUE_TO_NEXT_FAIL = '[DWSM TMO Page] Verify TVG and continue to next fail',
    UNVERIFY_TVG = '[DWSM TMO Page] Unverify TVG',
    UNVERIFY_TVG_SUCCESS = '[DWSM TMO Page] Unverify TVG success',
    UNVERIFY_TVG_FAIL = '[DWSM TMO Page] Unverify TVG fail',
    RETURN_TO_OVERVIEW_PAGE = '[DWSM TMO Page] Return to overview page',
    CREATE_ANALYSIS_PREVIEW_TMO = '[DWSM Page] Create analysis preview TMO',
    CREATE_ANALYSIS_PREVIEW_TMO_SUCCESS = '[DWSM Page] Create analysis preview TMO success',
    CREATE_ANALYSIS_PREVIEW_TMO_FAIL = '[DWSM Page] Create analysis preview TMO fail',
    GET_JOB_BY_ID = '[DWSM Page] Get DWSM job by id',
    GET_JOB_BY_ID_SUCCESS = '[DWSM Page] Get dwsm job by id success',
    GET_JOB_BY_ID_FAIL = '[DWSM Page] Get dwsm job by id fail',
    POLL_JOB_STATUS_SUCCESS = '[DWSM Page] Poll job status success',
    POLL_JOB_STATUS_FAIL = '[DWSM Page] Poll job status fail',
    START_PROCESS_VIDEO = '[DWSM Lite TMO] Start process Video',
    START_PROCESS_VIDEO_SUCCESS = '[DWSM Lite TMO] Start process Video success',
    START_PROCESS_VIDEO_FAIL = '[DWSM Lite TMO] Start process Video fail',
    PROCESS_VIDEO_SUCCESS = '[DWSM Lite TMO] Process video success',
    PROCESS_VIDEO_FAIL = '[DWSM Lite TMO] Process video fail',
    EXIT_DWSM_TMO_LITE_PROCESS = '[DWSM Lite TMO] Exit DWSM TMO Lite process',
    GET_DWSM_LITE_MOBILE_TMO = '[DWSM Lite TMO] Get DWSM Lite Mobile TMO',
    GET_DWSM_LITE_MOBILE_TMO_SUCCESS = '[DWSM Lite TMO] Get DWSM Lite Mobile TMO success',
    GET_DWSM_LITE_MOBILE_TMO_FAIL = '[DWSM Lite TMO] Get DWSM Lite Mobile TMO fail',
    PROCESS_DWSM_LITE_MOBILE_TMO = '[DWSM Lite TMO] Process DWSM Lite Mobile TMO'
}
export const openDWSMPopup = createAction(ActionTypes.OPEN_DWSM_POPUP);

export const closeDWSMPopup = createAction(ActionTypes.CLOSE_DWSM_POPUP);

export const getUploadOverview = createAction(ActionTypes.GET_UPLOAD_OVERVIEW, props<{ dwsmJobId: number }>());

export const startDWSMUpload = createAction(ActionTypes.START_DWSM_UPLOAD, props<{ files: File[]; params: DWSMParams }>());

export const dwsmUploadSuccess = createAction(ActionTypes.DWSM_UPLOAD_SUCCESS, props<{ dwsmJob: DWSMJob }>());

export const dwsmUploadFail = createAction(ActionTypes.DWSM_UPLOAD_FAIL, props<{ systemError: SystemError }>());

export const startDWSMLiteTmoUpload = createAction(
    ActionTypes.START_DWSM_LITE_TMO_UPLOAD,
    props<{ file: File; description: string | undefined; analysisKey: string; version: string }>()
);

export const startDWSMLiteTmoUploadSuccess = createAction(
    ActionTypes.START_DWSM_LITE_TMO_UPLOAD_SUCCESS,
    props<{ file: ArrayBuffer; fileName: string; description: string | undefined; key: string; version: string; dropdownTvgDTOList: DropdownTvgDTO[] }>()
);

export const startDWSMLiteTmoUploadFail = createAction(ActionTypes.START_DWSM_LITE_TMO_UPLOAD_FAIL, props<{ systemError: SystemError }>());

export const getCalculationsForCurrentJob = createAction(ActionTypes.GET_CALCULATIONS_FOR_CURRENT_JOB);

export const getCalculationsForCurrentJobSuccess = createAction(
    ActionTypes.GET_CALCULATIONS_FOR_CURRENT_JOB_SUCCESS,
    props<{ calculation: DWSMCalculationDTO }>()
);

export const getCalculationsForCurrentJobFail = createAction(ActionTypes.GET_CALCULATIONS_FOR_CURRENT_JOB_FAIL, props<{ systemError: SystemError }>());

export const getCalculationsByJobId = createAction(ActionTypes.GET_CALCULATIONS_BY_JOB_ID, props<{ jobId: number }>());

export const getCalculationsByJobIdSuccess = createAction(ActionTypes.GET_CALCULATIONS_BY_JOB_ID_SUCCESS, props<{ calculation: DWSMCalculationDTO }>());

export const getCalculationsByJobIdFail = createAction(ActionTypes.GET_CALCULATIONS_BY_JOB_ID_FAIL, props<{ systemError: SystemError }>());

export const getUploadOverviewSuccess = createAction(ActionTypes.GET_UPLOAD_OVERVIEW_SUCCESS, props<{ uploadOverview: UploadOverviewDTO }>());

export const getUploadOverviewFail = createAction(ActionTypes.GET_UPLOAD_OVERVIEW_FAIL, props<{ systemError: SystemError }>());

export const getStatusAndTaskLengthByJobId = createAction(ActionTypes.GET_STATUS_AND_TASK_LENGTH_BY_JOB_ID, props<{ dwsmJobId: number }>());

export const getStatusAndTaskLengthByJobIdSuccess = createAction(
    ActionTypes.GET_STATUS_AND_TASK_LENGTH_BY_JOB_ID_SUCCESS,
    props<{ response: ResponseStatusAndTaskLengthByJobId }>()
);

export const getStatusAndTaskLengthByJobIdFail = createAction(ActionTypes.GET_STATUS_AND_TASK_LENGTH_BY_JOB_ID_FAIL, props<{ systemError: SystemError }>());

export const cancelDWSMUpload = createAction(ActionTypes.CANCEL_DWSM_UPLOAD);

export const startRedirectProcessForSingleFileUpload = createAction(
    ActionTypes.START_REDIRECT_PROCESS_FOR_SINGLE_FILE_UPLOAD,
    props<{ dwsmJobId: number; overwriteTaskLength: boolean; variant?: DwsmResultVariant }>()
);

export const openSingleAnalysisFromMvnxSuccess = createAction(ActionTypes.OPEN_SINGLE_ANALYSIS_FROM_MVNX_SUCCESS, props<{ analysis: Analysis }>());

export const openSingleAnalysisFromMvnxFail = createAction(ActionTypes.OPEN_SINGLE_ANALYSIS_FROM_MVNX_FAIL, props<{ systemError: SystemError }>());

export const startRedirectProcessForTMOAndMultipleFilesUpload = createAction(
    ActionTypes.START_REDIRECT_PROCESS_FOR_TMO_AND_MULTIPLES_FILES_UPLOAD,
    props<{ dwsmJobId: number; jobType: JobType; overwriteTaskLength: boolean; variant?: DwsmResultVariant }>()
);

export const transferResultsToCacheByJobIdSuccess = createAction(ActionTypes.TRANSFER_RESULTS_TO_CACHE_BY_JOB_ID_SUCCESS, props<{ jobType: JobType }>());

export const transferResultsToCacheByJobIdFail = createAction(ActionTypes.TRANSFER_RESULTS_TO_CACHE_BY_JOB_ID_FAIL, props<{ systemError: SystemError }>());

export const saveDWSMAnalysisInCacheSuccess = createAction(ActionTypes.SAVE_ANALYSIS_IN_CACHE_SUCCESS, props<{ analysis: Analysis }>());

export const saveDWSMAnalysisInCacheFail = createAction(ActionTypes.SAVE_ANALYSIS_IN_CACHE_FAIL, props<{ systemError: SystemError }>());

export const setAdvancedSettingsPersonalDefaults = createAction(ActionTypes.SET_ADVANCED_SETTINGS_PERSONAL_DEFAULTS, props<{ dwsmConfig: DWSMConfig }>());

export const setAdvancedSettingsPersonalDefaultsSuccess = createAction(
    ActionTypes.SET_ADVANCED_SETTINGS_PERSONAL_DEFAULTS_SUCCESS,
    props<{ dwsmConfig: DWSMConfig; message: string }>()
);

export const setAdvancedSettingsPersonalDefaultsFail = createAction(
    ActionTypes.SET_ADVANCED_SETTINGS_PERSONAL_DEFAULTS_FAIL,
    props<{ systemError: SystemError }>()
);

export const reAnalyzeWithCurrentInputs = createAction(ActionTypes.REANALYZE_WITH_CURRENT_INPUTS, props<{ dwsmConfig: DWSMConfig }>());

export const reAnalyzeWithCurrentInputsSuccess = createAction(
    ActionTypes.REANALYZE_WITH_CURRENT_INPUTS_SUCCESS,
    props<{ uploadOverview: UploadOverviewDTO }>()
);

export const reAnalyzeWithCurrentInputsFail = createAction(ActionTypes.REANALYZE_WITH_CURRENT_INPUTS_FAIL, props<{ systemError: SystemError }>());

export const updateStatusOutlierObject = createAction(
    ActionTypes.UPDATE_STATUS_OUTLIER_OBJECT,
    props<{ fileStatusUpdateOutliers: FileStatusUpdateOutliers }>()
);

export const updateStatusOutlierObjectSuccess = createAction(
    ActionTypes.UPDATE_STATUS_OUTLIER_OBJECT_SUCCESS,
    props<{ verifyXsensDataTable: VerifyXsensDataTable }>()
);

export const updateStatusOutlierObjectFail = createAction(ActionTypes.UPDATE_STATUS_OUTLIER_OBJECT_FAIL, props<{ systemError: SystemError }>());

export const resetVerifyXsensDataForCurrentJob = createAction(ActionTypes.RESET_VERIFY_XSENS_DATA_FOR_CURRENT_JOB);

export const resetVerifyXsensDataForCurrentJobSuccess = createAction(
    ActionTypes.RESET_VERIFY_XSENS_DATA_FOR_CURRENT_JOB_SUCCESS,
    props<{ verifyXsensDataTable: VerifyXsensDataTable }>()
);

export const resetVerifyXsensDataForCurrentJobFail = createAction(
    ActionTypes.RESET_VERIFY_XSENS_DATA_FOR_CURRENT_JOB_FAIL,
    props<{ systemError: SystemError }>()
);

export const createAnalysisMultipleFilesByJobId = createAction(ActionTypes.CREATE_ANALYSIS_BY_JOB_ID, props<{ overwriteTaskLength: boolean }>());

export const createAnalysisMultipleFilesByJobIdSuccess = createAction(ActionTypes.CREATE_ANALYSIS_BY_JOB_ID_SUCCESS, props<{ analysis: Analysis }>());

export const createAnalysisMultipleFilesByJobIdFail = createAction(ActionTypes.CREATE_ANALYSIS_BY_JOB_ID_FAIL, props<{ systemError: SystemError }>());

export const fileStatusUpdate = createAction(ActionTypes.FILE_STATUS_UPDATE, props<{ fileStatus: FileStatus; ranValidation: boolean }>());

export const fileStatusUpdateSuccess = createAction(ActionTypes.FILE_STATUS_UPDATE_SUCCESS, props<{ mainObject: MainObject; ranValidation: boolean }>());

export const fileStatusUpdateFail = createAction(ActionTypes.FILE_STATUS_UPDATE_FAIL, props<{ systemError: SystemError }>());

export const fileMoveForceCase = createAction(ActionTypes.FILE_MOVE_FORCE_CASE, props<{ fileMoveForceCase: FileMoveForceCase; ranValidation: boolean }>());

export const fileMoveForceCaseSuccess = createAction(ActionTypes.FILE_MOVE_FORCE_CASE_SUCCESS, props<{ mainObject: MainObject; ranValidation: boolean }>());

export const fileMoveForceCaseFail = createAction(ActionTypes.FILE_MOVE_FORCE_CASE_FAIL, props<{ systemError: SystemError }>());

export const resetMainObjectByJobId = createAction(ActionTypes.RESET_MAIN_OBJECT_BY_JOB_ID);

export const resetMainObjectByJobIdSuccess = createAction(ActionTypes.RESET_MAIN_OBJECT_BY_JOB_ID_SUCCESS, props<{ mainObject: MainObject }>());

export const resetMainObjectByJobIdFail = createAction(ActionTypes.RESET_MAIN_OBJECT_BY_JOB_ID_FAIL, props<{ systemError: SystemError }>());

export const updateDescriptionOnForceCase = createAction(
    ActionTypes.UPDATE_DESCRIPTION_ON_FORCE_CASE,
    props<{ description: string; forceCaseIndex: number; ranValidation: boolean }>()
);

export const validateForceCaseFields = createAction(ActionTypes.VALIDATE_FORCE_CASE_FIELDS);

export const updateForceCaseCriterion = createAction(
    ActionTypes.UPDATE_FORCE_CASE_CRITERION,
    props<{ criterionUpdate: CriterionUpdate; ranValidation: boolean }>()
);

export const updateForceCaseCriterionSuccess = createAction(
    ActionTypes.UPDATE_FORCE_CASE_CRITERION_SUCCESS,
    props<{ mainObject: MainObject; ranValidation: boolean }>()
);

export const updateForceCaseCriterionFail = createAction(ActionTypes.UPDATE_FORCE_CASE_CRITERION_FAIL, props<{ systemError: SystemError }>());

export const updateForceCaseForceValue = createAction(
    ActionTypes.UPDATE_FORCE_CASE_FORCE_VALUE,
    props<{ isMaxForce: boolean; force: number; forceCase: ForceCase; forceCaseIndex: number }>()
);

export const updateForceCaseInputField = createAction(
    ActionTypes.UPDATE_FORCE_CASE_FORCE_VALUE,
    props<{ value: number; forceCase: ForceCase; inputField: string; forceCaseIndex: number }>()
);

export const getDwsmDashboard = createAction(ActionTypes.GET_DWSM_DASHBOARD);

export const getDwsmDashboardSuccess = createAction(ActionTypes.GET_DWSM_DASHBOARD_SUCCESS, props<{ dwsmDashboardEntries: DWSMDashboardEntry[] }>());

export const getDwsmDashboardFail = createAction(ActionTypes.GET_DWSM_DASHBOARD_FAIL, props<{ systemError: SystemError }>());

export const getDwsmLiteDashboardSuccess = createAction(
    ActionTypes.GET_DWSM_LITE_DASHBOARD_SUCCESS,
    props<{ dwsmLiteDashboardEntries: DWSMDashboardEntry[] }>()
);

export const getDwsmLiteDashboardFail = createAction(ActionTypes.GET_DWSM_LITE_DASHBOARD_FAIL, props<{ systemError: SystemError }>());

export const getDwsmTmoDashboardSuccess = createAction(ActionTypes.GET_DWSM_TMO_DASHBOARD_SUCCESS, props<{ dwsmTmoDashboardEntries: DWSMDashboardEntry[] }>());

export const getDwsmTmoDashboardFail = createAction(ActionTypes.GET_DWSM_TMO_DASHBOARD_FAIL, props<{ systemError: SystemError }>());

export const deleteDwsmJobById = createAction(ActionTypes.DELETE_DWSM_JOB_BY_ID, props<{ dwsmJobId: number; isTmo: boolean; isLite: boolean }>());

export const deleteDwsmJobByIdSuccess = createAction(ActionTypes.DELETE_DWSM_JOB_BY_ID_SUCCESS, props<{ dwsmJobId: number }>());

export const deleteDwsmJobByIdFail = createAction(
    ActionTypes.DELETE_DWSM_JOB_BY_ID_FAIL,
    props<{ systemError: SystemError; isTmo: boolean; isLite: boolean }>()
);

export const openDWSMPopupFromDashboardEntry = createAction(ActionTypes.OPEN_DWSM_POPUP_FROM_DASHBOARD_ENTRY, props<{ dwsmJob: DWSMJob }>());

export const setDashboardEntryToState = createAction(ActionTypes.SET_DASHBOARD_ENTRY_TO_STATE, props<{ dwsmJob: DWSMJob }>());

export const updateJobToFinished = createAction(ActionTypes.UPDATE_JOB_TO_FINISHED, props<{ dwsmJobId: number }>());

export const updateJobToFinishedSuccess = createAction(ActionTypes.UPDATE_JOB_TO_FINISHED_SUCCESS);

export const updateJobToFinishedFail = createAction(ActionTypes.UPDATE_JOB_TO_FINISHED_FAIL, props<{ systemError: SystemError }>());

export const getUploadOverviewTmo = createAction(ActionTypes.GET_UPLOAD_OVERVIEW_TMO, props<{ dwsmJobId: number }>());

export const getUploadOverviewTmoSuccess = createAction(
    ActionTypes.GET_UPLOAD_OVERVIEW_TMO_SUCCESS,
    props<{
        overviewTmo: OverviewTMO;
    }>()
);

export const getUploadOverviewTmoFail = createAction(
    ActionTypes.GET_UPLOAD_OVERVIEW_TMO_FAIL,
    props<{
        systemError: SystemError;
    }>()
);

export const resetOverviewTmo = createAction(ActionTypes.RESET_OVERVIEW_TMO);

export const resetOverviewTmoSuccess = createAction(
    ActionTypes.RESET_OVERVIEW_TMO_SUCCESS,
    props<{
        overviewTmo: OverviewTMO;
    }>()
);

export const resetOverviewTmoFail = createAction(
    ActionTypes.RESET_OVERVIEW_TMO_TMO_FAIL,
    props<{
        systemError: SystemError;
    }>()
);

export const updateFileStatus = createAction(
    ActionTypes.UPDATE_FILE_STATUS,
    props<{
        updateFileStatusParams: UpdateFileStatusParams;
    }>()
);

export const updateFileStatusSuccess = createAction(
    ActionTypes.UPDATE_FILE_STATUS_SUCCESS,
    props<{
        overviewTmo: OverviewTMO;
    }>()
);

export const updateFileStatusFail = createAction(
    ActionTypes.UPDATE_FILE_STATUS_FAIL,
    props<{
        systemError: SystemError;
    }>()
);

export const revertUpdateFileStatus = createAction(
    ActionTypes.REVERT_UPDATE_FILE_STATUS,
    props<{
        updateFileStatusParams: UpdateFileStatusParams;
    }>()
);

export const updateTmoProcessFrequency = createAction(
    ActionTypes.UPDATE_TMO_PROCESS_FREQUENCY,
    props<{
        processFrequency: number;
    }>()
);

export const recalculateTmo = createAction(ActionTypes.RECALCULATE_TMO);

export const recalculateTmoSuccess = createAction(
    ActionTypes.RECALCULATE_TMO_SUCCESS,
    props<{
        overviewTmo: OverviewTMO;
    }>()
);

export const recalculateTmoFail = createAction(
    ActionTypes.RECALCULATE_TMO_FAIL,
    props<{
        systemError: SystemError;
    }>()
);

export const loadDwsmModule = createAction(ActionTypes.LOAD_DWSM_MODULE);

export const openForceCaseTypePopup = createAction(ActionTypes.OPEN_FORCE_CASE_TYPE_POPUP);

export const closeForceCaseTypePopup = createAction(ActionTypes.CLOSE_FORCE_CASE_TYPE_POPUP);

export const updateDWSMForceCaseType = createAction(
    ActionTypes.UPDATE_DWSM_FORCE_CASE_TYPE,
    props<{ forceCaseIndex: number; forceCaseType: GloveForceCase }>()
);

export const updateDWSMForceCaseInput = createAction(
    ActionTypes.UPDATE_DWSM_FORCE_CASE_INPUT,
    props<{ forceCaseIndex: number; inputToChange: string; value: any }>()
);

export const updateGraphDataDatasetOverride = createAction(
    ActionTypes.UPDATE_GRAPH_DATA_DATASET_OVERRIDE,
    props<{
        forceCaseIndex: number;
        repetitionIndex: number;
        elementIndex: number;
    }>()
);

export const updateActiveMarkers = createAction(ActionTypes.UPDATE_ACTIVE_MARKERS, props<{ variant: VariantDTO; marker: Marker }>());

export const updateVariantTvgList = createAction(
    ActionTypes.UPDATE_VARIANT_TVG_LIST,
    props<{ variant: VariantDTO; tvg: TvgTableItemDTO; isActive: boolean }>()
);

export const reorderActiveMarkers = createAction(
    ActionTypes.REORDER_ACTIVE_MARKERS,
    props<{
        variant: VariantDTO;
        marker: Marker;
        markersList: Marker[];
        droppedMarkerIndex: number;
        draggedMarkerIndex: number;
    }>()
);

export const backToTvgOrder = createAction(ActionTypes.BACK_TO_TVG_ORDER, props<{ verify: boolean }>());

export const createAnalysisFromTmo = createAction(ActionTypes.CREATE_ANALYSIS_FROM_TMO, props<{ validFromTomorrow: boolean }>());

export const createAnalysisFromTmoSuccess = createAction(
    ActionTypes.CREATE_ANALYSIS_FROM_TMO_SUCCESS,
    props<{ analysisKey: string | undefined; version: number | undefined }>()
);

export const createAnalysisFromTmoFail = createAction(ActionTypes.CREATE_ANALYSIS_FROM_TMO_FAIL, props<{ systemError: SystemError }>());

export const updateActiveVariant = createAction(ActionTypes.UPDATE_ACTIVE_VARIANT, props<{ variantUUID: string }>());

export const addVariant = createAction(ActionTypes.ADD_VARIANT);

export const addVariantSuccess = createAction(ActionTypes.ADD_VARIANT_SUCCESS, props<{ overviewTmo: OverviewTMO }>());

export const addVariantFail = createAction(ActionTypes.ADD_VARIANT_FAIL, props<{ systemError: SystemError }>());

export const deleteVariant = createAction(ActionTypes.DELETE_VARIANT, props<{ variantUUID: string }>());

export const deleteVariantSuccess = createAction(ActionTypes.DELETE_VARIANT_SUCCESS, props<{ overviewTmo: OverviewTMO; variantIndex: number }>());

export const deleteVariantFail = createAction(ActionTypes.DELETE_VARIANT_FAIL, props<{ systemError: SystemError }>());

export const quickVerifyTmo = createAction(ActionTypes.QUICK_VERIFY_TMO, props<{ tvgId: string; verify: boolean }>());

export const quickVerifyTmoSuccess = createAction(ActionTypes.QUICK_VERIFY_TMO_SUCCESS, props<{ overviewTmo: OverviewTMO }>());

export const quickVerifyTmoFail = createAction(ActionTypes.QUICK_VERIFY_TMO_FAIL, props<{ systemError: SystemError }>());

export const verifyAllTmo = createAction(ActionTypes.VERIFY_ALL_TMO, props<{ verify: boolean }>());

export const verifyAllTmoSuccess = createAction(ActionTypes.VERIFY_ALL_TMO_SUCCESS, props<{ overviewTmo: OverviewTMO; isToGoBackToTvg: boolean }>());

export const verifyAllTmoFail = createAction(ActionTypes.VERIFY_ALL_TMO_FAIL, props<{ systemError: SystemError }>());

export const startVerifyTvg = createAction(ActionTypes.GET_CALCULATIONS_FOR_TVG, props<{ tvgId: string }>());

export const startVerifyTvgSuccess = createAction(ActionTypes.GET_CALCULATIONS_FOR_TVG_SUCCESS, props<{ calculation: DWSMCalculationDTO }>());

export const startVerifyTvgFail = createAction(ActionTypes.GET_CALCULATIONS_FOR_TVG_FAIL, props<{ systemError: SystemError }>());

export const verifyTvgAndReturnToOverview = createAction(ActionTypes.VERIFY_TVG_AND_RETURN_TO_OVERVIEW, props<{ tvgId: string }>());

export const verifyTvgAndReturnToOverviewSuccess = createAction(
    ActionTypes.VERIFY_TVG_AND_RETURN_TO_OVERVIEW_SUCCESS,
    props<{ tvgId: string; overviewTmo: OverviewTMO }>()
);

export const verifyTvgAndReturnToOverviewFail = createAction(ActionTypes.VERIFY_TVG_AND_RETURN_TO_OVERVIEW_FAIL, props<{ systemError: SystemError }>());

export const verifyTvgAndContinueToNext = createAction(ActionTypes.VERIFY_TVG_AND_CONTINUE_TO_NEXT, props<{ tvgId: string }>());

export const verifyTvgAndContinueToNextSuccess = createAction(
    ActionTypes.VERIFY_TVG_AND_CONTINUE_TO_NEXT_SUCCESS,
    props<{ overviewTmo: OverviewTMO; calculation: DWSMCalculationDTO }>()
);

export const verifyTvgAndContinueToNextFail = createAction(ActionTypes.VERIFY_TVG_AND_CONTINUE_TO_NEXT_FAIL, props<{ systemError: SystemError }>());

export const unverifyTvg = createAction(ActionTypes.UNVERIFY_TVG, props<{ tvgId: string }>());

export const unverifyTvgSuccess = createAction(ActionTypes.UNVERIFY_TVG_SUCCESS, props<{ overviewTmo: OverviewTMO }>());

export const unverifyTvgFail = createAction(ActionTypes.UNVERIFY_TVG_FAIL, props<{ systemError: SystemError }>());

export const returnToOverviewPage = createAction(ActionTypes.RETURN_TO_OVERVIEW_PAGE);

export const createAnalysisPreviewTMO = createAction(ActionTypes.CREATE_ANALYSIS_PREVIEW_TMO);

export const createAnalysisPreviewTMOSuccess = createAction(ActionTypes.CREATE_ANALYSIS_PREVIEW_TMO_SUCCESS, props<{ analysis: Analysis }>());

export const createAnalysisPreviewTMOFail = createAction(ActionTypes.CREATE_ANALYSIS_PREVIEW_TMO_FAIL, props<{ systemError: SystemError }>());

export const getDWSMJobById = createAction(ActionTypes.GET_JOB_BY_ID, props<{ dwsmJobId: number }>());

export const getDWSMJobByIdSuccess = createAction(ActionTypes.GET_JOB_BY_ID_SUCCESS, props<{ dwsmJob: DWSMJob }>());

export const getDWSMJobByIdFail = createAction(ActionTypes.GET_JOB_BY_ID_FAIL, props<{ systemError: SystemError }>());

export const pollJobStatusSuccess = createAction(ActionTypes.POLL_JOB_STATUS_SUCCESS, props<{ response: ResponseStatusAndTaskLengthByJobId }>());

export const pollJobStatusFail = createAction(ActionTypes.POLL_JOB_STATUS_FAIL, props<{ systemError: SystemError }>());

export const startProcessVideo = createAction(
    ActionTypes.START_PROCESS_VIDEO,
    props<{ analysisKey: string; version: string; markers: VideoMarkerDTO[]; jobId: number | null }>()
);

export const startProcessVideoSuccess = createAction(ActionTypes.START_PROCESS_VIDEO_SUCCESS, props<{ dwsmJob: DWSMJob }>());

export const startProcessVideoFail = createAction(ActionTypes.START_PROCESS_VIDEO_FAIL, props<{ systemError: SystemError }>());

export const processVideoSuccess = createAction(
    ActionTypes.PROCESS_VIDEO_SUCCESS,
    props<{ dwsmJobId: number; jobType: JobType; variant?: DwsmResultVariant }>()
);

export const processVideoFail = createAction(ActionTypes.PROCESS_VIDEO_FAIL, props<{ systemError: SystemError }>());

export const exitDwsmLiteTmoProcess = createAction(ActionTypes.EXIT_DWSM_TMO_LITE_PROCESS);

export const getDWSMLiteMobileTmo = createAction(ActionTypes.GET_DWSM_LITE_MOBILE_TMO, props<{ dwsmJobId: number }>());

export const getDWSMLiteMobileTmoSuccess = createAction(
    ActionTypes.GET_DWSM_LITE_MOBILE_TMO_SUCCESS,
    props<{ file: ArrayBuffer; fileName: string; description: string | undefined; key: string; version: string; dropdownTvgDTOList: DropdownTvgDTO[] }>()
);

export const getDWSMLiteMobileTmoFail = createAction(ActionTypes.GET_DWSM_LITE_MOBILE_TMO_FAIL, props<{ systemError: SystemError }>());

export const processDWSMLiteMobileTmo = createAction(
    ActionTypes.PROCESS_DWSM_LITE_MOBILE_TMO,
    props<{ analysisKey: string; version: string; markers: VideoMarkerDTO[] }>()
);
